(function () {
  const GIFT_WRAP_VARIANT_ID = 9129737847034;
  const REDIRECT_TO_CART_PAGE = true; // true: カート画面へ遷移 / false: ドロワーを開く挑戦をする

  function getProductForm(target) {
    if (!target || !(target instanceof HTMLElement)) return null;
    return target.closest('form[action*="/cart/add"]');
  }

  function getCheckboxFromForm(form) {
    return form.querySelector('[data-free-gift-wrap-checkbox]');
  }

  function getGiftWrapContainer(form) {
    return form.querySelector('[data-free-gift-wrap]');
  }

  function getSelectedVariantId(formData) {
    return formData.get('id');
  }

  function getQuantity(formData) {
    const qty = parseInt(formData.get('quantity') || '1', 10);
    return Number.isNaN(qty) || qty < 1 ? 1 : qty;
  }

  function getLineItemProperties(formData) {
    const properties = {};
    for (const [key, value] of formData.entries()) {
      if (key.startsWith('properties[') && key.endsWith(']')) {
        const propName = key.replace('properties[', '').replace(']', '');
        properties[propName] = value;
      }
    }
    return properties;
  }

  function openCartDrawerOrRedirect() {
    if (REDIRECT_TO_CART_PAGE) {
      window.location.href = window.Shopify.routes.root + 'cart';
      return;
    }

    // Prestigeのバージョン差異があるため、まずイベントを投げる
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));

    // 念のため少し待って開かなければカートへ
    setTimeout(function () {
      window.location.href = window.Shopify.routes.root + 'cart';
    }, 500);
  }

  async function addMainAndGiftWrap(form) {
    const formData = new FormData(form);
    const variantId = getSelectedVariantId(formData);

    if (!variantId) {
      console.error('Variant ID not found in product form.');
      return;
    }

    const quantity = getQuantity(formData);
    const properties = getLineItemProperties(formData);
    const sellingPlan = formData.get('selling_plan');

    const mainItem = {
      id: Number(variantId),
      quantity: quantity
    };

    if (Object.keys(properties).length > 0) {
      mainItem.properties = properties;
    }

    if (sellingPlan) {
      mainItem.selling_plan = sellingPlan;
    }

    const giftItem = {
      id: Number(GIFT_WRAP_VARIANT_ID),
      quantity: 1,
      properties: {
        _free_gift_wrap_for_variant: String(variantId)
      }
    };

    const payload = {
      items: [mainItem, giftItem]
    };

    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || 'Failed to add items to cart.');
    }

    return response.json();
  }

  document.addEventListener(
    'submit',
    async function (event) {
      const form = getProductForm(event.target);
      if (!form) return;

      const checkbox = getCheckboxFromForm(form);
      const container = getGiftWrapContainer(form);

      // この商品にオプションが出ていないなら何もしない
      if (!checkbox || !container) return;

      // チェックなしは既存テーマ挙動をそのまま使う
      if (!checkbox.checked) return;

      // 二重送信防止
      if (form.dataset.freeGiftWrapSubmitting === 'true') {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      form.dataset.freeGiftWrapSubmitting = 'true';

      const submitButton =
        form.querySelector('button[type="submit"]') ||
        form.querySelector('[name="add"]');

      const originalDisabled = submitButton ? submitButton.disabled : null;
      if (submitButton) {
        submitButton.disabled = true;
      }

      try {
        await addMainAndGiftWrap(form);
        openCartDrawerOrRedirect();
      } catch (error) {
        console.error('Gift wrap add-to-cart error:', error);

        // エラー時は通常送信にフォールバックしたいなら下2行を使う
        // form.dataset.freeGiftWrapSubmitting = 'false';
        // form.submit();

        alert('カート追加時にエラーが発生しました。もう一度お試しください。');
      } finally {
        form.dataset.freeGiftWrapSubmitting = 'false';
        if (submitButton && originalDisabled !== null) {
          submitButton.disabled = originalDisabled;
        }
      }
    },
    true
  );
})();